import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BookOpen, Package } from '@phosphor-icons/react';
import LibraryPage from './LibraryPage';
import MaterialsCatalogPage from './MaterialsCatalogPage';

/**
 * Combined view for "Bibliothèque (articles) + Catalogue matériaux".
 * Both share the same parent tab "Bibliothèque & Catalogue" — sub-tabs
 * let the user switch between articles and raw materials catalogue.
 *
 * Sub-tab can be controlled via the `sub` URL parameter
 * (`?tab=bibliotheque_catalogue&sub=materiaux`).
 */
const LibraryAndCatalogPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlSub = searchParams.get('sub');
  const [sub, setSub] = useState(urlSub === 'materiaux' ? 'materiaux' : 'articles');

  useEffect(() => {
    if (urlSub === 'materiaux' || urlSub === 'articles') {
      if (urlSub !== sub) setSub(urlSub);
    }
  }, [urlSub, sub]);

  const handleSubChange = (v) => {
    setSub(v);
    const next = new URLSearchParams(searchParams);
    next.set('sub', v);
    setSearchParams(next, { replace: true });
  };

  const SUBS = [
    { key: 'articles', label: 'Articles', icon: BookOpen },
    { key: 'materiaux', label: 'Matériaux', icon: Package },
  ];

  return (
    <div data-testid="library-catalog-page">
      <div
        role="tablist"
        style={{
          display: 'inline-flex',
          gap: 0,
          padding: 4,
          borderRadius: 999,
          border: '1px solid #E2E2E6',
          background: '#F4F5F7',
          marginBottom: 18,
        }}
      >
        {SUBS.map((s) => {
          const Icon = s.icon;
          const active = sub === s.key;
          return (
            <button
              key={s.key}
              role="tab"
              aria-selected={active}
              data-testid={`library-catalog-sub-${s.key}`}
              onClick={() => handleSubChange(s.key)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '8px 18px',
                border: 'none',
                cursor: 'pointer',
                borderRadius: 999,
                fontSize: '0.85rem',
                fontWeight: 600,
                background: active ? '#002FA7' : 'transparent',
                color: active ? 'white' : '#5E5F66',
                transition: 'background 0.15s ease, color 0.15s ease',
              }}
            >
              <Icon size={16} weight={active ? 'fill' : 'regular'} />
              {s.label}
            </button>
          );
        })}
      </div>

      {sub === 'articles' && <LibraryPage />}
      {sub === 'materiaux' && <MaterialsCatalogPage />}
    </div>
  );
};

export default LibraryAndCatalogPage;
